import { Component, Input, OnInit } from '@angular/core';
import {
  RailCardQualifiers,
  ReferenceRailCardQualifier,
  EnterpriseSearchService,
  ServiceType,
  DiscountType,
  BasketItem
} from '@sabstravtech/obtservices/angular';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { RailEnterpriseSearchInterface, ServiceProvider } from '@sabstravtech/obtservices/base';
import _ from 'lodash';

import { ThemeService } from '../../../../../core/services/theme.service';
import { BaseComponent } from '../../../../../core/components/base_components/base-componet';

type GroupedRailCard = { count: number; description: string };
@Component({
  selector: 'app-rail-cards',
  templateUrl: './rail-cards.component.html',
  styleUrls: ['./rail-cards.component.scss'],
  standalone: false
})
export class RailCardsComponent extends BaseComponent implements OnInit {
  @Input() trainlineRailcards: GroupedRailCard[] = [];
  @Input() type: ServiceProvider.Evolvi | ServiceProvider.Trainline = ServiceProvider.Evolvi;
  @Input() railCardQualifiers: RailCardQualifiers[] = [];
  @Input() basketItem: BasketItem;
  @Input() inline = false;

  cards: GroupedRailCard[] = [];
  searchParams: RailEnterpriseSearchInterface;
  isScion = false;

  DiscountType: typeof DiscountType = DiscountType;
  ServiceType: typeof ServiceType = ServiceType;
  ServiceProvider: typeof ServiceProvider = ServiceProvider;

  constructor(
    public searchService: EnterpriseSearchService,
    title: Title,
    public translateService: TranslateService,
    protected themeService: ThemeService
  ) {
    super(title, translateService);
  }

  ngOnInit(): void {
    this.searchParams = this.searchService.searches[ServiceType.Rail];
    this.isScion = this.themeService.isScionEnv;

    if (this.type === ServiceProvider.Trainline) {
      this.cards = this.groupCardsFromTrainline(this.trainlineRailcards);
    } else {
      this.loadRailCards(this.railCardQualifiers);
    }
  }

  /**
   * Group Trainline discount cards
   */
  groupCardsFromTrainline(card: GroupedRailCard[]): GroupedRailCard[] {
    return _.map(_.groupBy(card, 'code'), (items) => ({
      ...items[0],
      count: items.length
    }));
  }

  /**
   * Load getRailCards and group the incoming raw cards.
   */
  private loadRailCards(cards: RailCardQualifiers[]): void {
    const region = this.searchParams?.ukRail ? 'GB' : 'EU';

    this.subscribe(
      this.searchService.getRailCards(region),
      (referenceCards: ReferenceRailCardQualifier[] = []) => {
        this.cards = this.groupCardsWithDescriptions(cards, referenceCards);
      }
    );
  }

  /**
   * Group rail cards and match their codes to readable names.
   */
  private groupCardsWithDescriptions(
    cards: RailCardQualifiers[],
    referenceCards: ReferenceRailCardQualifier[]
  ): GroupedRailCard[] {
    const counts = _.countBy(cards, 'code');

    return Object.entries(counts).map(([code, count]) => {
      const description = referenceCards.find((c) => c.code === code)?.name || code;

      return { description, count };
    });
  }
}
